import { render, staticRenderFns } from "./ProductThicknessesList.vue?vue&type=template&id=01521ea3&scoped=true"
import script from "./ProductThicknessesList.vue?vue&type=script&lang=js"
export * from "./ProductThicknessesList.vue?vue&type=script&lang=js"
import style0 from "./ProductThicknessesList.vue?vue&type=style&index=0&id=01521ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01521ea3",
  null
  
)

export default component.exports